import { CampaignTypeV1 } from '~/api/v1/schemas/campaign-type';
import { CampaignTypeV2 } from '~/api/v2/schemas/campaign-type';

/**
 * Determines the campaign type based on the campaign ID / キャンペーンIDに基づいてキャンペーンタイプを判定します
 *
 * This function uses a simple rule to determine campaign type: IDs less than 1,000,000 are SHOP campaigns,
 * while IDs equal to or greater than 1,000,000 are OFFER campaigns.
 * シンプルなルールを使用してキャンペーンタイプを判定します：IDが1,000,000未満の場合はSHOPキャンペーン、
 * 1,000,000以上の場合はOFFERキャンペーンです。
 *
 * @param {number} id - The campaign ID to check / チェックするキャンペーンID
 * @returns {CampaignTypeV1 | CampaignTypeV2} The determined campaign type (SHOP or OFFER) / 判定されたキャンペーンタイプ（SHOPまたはOFFER）
 *
 * @example
 * // Returns CampaignTypeV1.SHOP for IDs less than 1,000,000 / IDが1,000,000未満の場合はCampaignTypeV1.SHOPを返します
 * determineCampaignTypeById(12345); // CampaignTypeV1.SHOP
 *
 * @example
 * // Returns CampaignTypeV1.OFFER for IDs >= 1,000,000 / IDが1,000,000以上の場合はCampaignTypeV1.OFFERを返します
 * determineCampaignTypeById(1234567); // CampaignTypeV1.OFFER
 */
export function determineCampaignTypeById(id: number): CampaignTypeV1 | CampaignTypeV2 {
  if (id < 1000000) {
    return CampaignTypeV1.SHOP;
  }
  return CampaignTypeV1.OFFER;
}
